export const TIME_FORMAT = {
  TIME_ZONE_FORMAT: 'HH:mm:ss O',
  DATE_TIME_ZONE_FORMAT: `yyyy-MM-dd, HH:mm:ss O`,
  DATE_TIME_FORMAT: 'd MMM y, HH:mm',
  SCORESHEET_DATE_TIME_FORMAT: 'EEEE, MMM d, y, HH:mm z',
  DATE_FORMAT: 'dd.MM.yy',
  TIME_WITH_SECONDS_FORMAT: 'mm:ss',
};
